<template>
    <vx-button-group
        :size="size"
        class="w-full"
        role="group"
        aria-label="Sort controls"
    >
        <vx-select
            :model-value="modelValue.field"
            @update:model-value="updateField"
            :options="options"
            :disabled="disabled || options.length <= 1"
            data-test="sort-field-select"
            aria-label="Select sort field"
        ></vx-select>
        <vx-button
            @click.prevent="toggleDirection"
            type="button"
            color="white"
            shadow
            :disabled="disabled || options.length === 0"
            data-test="sort-direction-button"
            :aria-label="`Sort ${modelValue.direction === 'asc' ? 'ascending' : 'descending'}. Press to toggle sort direction.`"
        >
            <font-awesome-icon
                widthAuto
                :icon="modelValue.direction === 'asc' ? faArrowUpWideShort : faArrowDownWideShort"
                aria-hidden="true"
            ></font-awesome-icon>
        </vx-button>
    </vx-button-group>
</template>

<script setup lang="ts">
import { VxButtonGroup, VxButton, VxSelect } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowUpWideShort, faArrowDownWideShort } from '@fortawesome/pro-solid-svg-icons';

export interface SortValue {
    field: string;
    direction: 'asc' | 'desc';
}

export interface SortOption {
    value: string;
    label: string;
}

export interface SortSelectorProps {
    modelValue: SortValue;
    options: SortOption[];
    disabled?: boolean;
    size?: 'sm' | 'md' | 'lg' | 'xl';
}

const props = withDefaults(defineProps<SortSelectorProps>(), {
    disabled: false,
    size: 'lg',
});

const emit = defineEmits<{
    'update:modelValue': [value: SortValue];
}>();

const updateField = (newField: string | number): void => {
    emit('update:modelValue', {
        ...props.modelValue,
        field: String(newField),
    });
};

const toggleDirection = (): void => {
    emit('update:modelValue', {
        ...props.modelValue,
        direction: props.modelValue.direction === 'asc' ? 'desc' : 'asc',
    });
};
</script>
